import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgClockAlwaysGlyphSecondary from './svgs/ClockAlwaysGlyphSecondary.js';
import SvgClockAlwaysGlyph from './svgs/ClockAlwaysGlyph.js';
import { useIcon } from '../../shared-components/icon/index.js';

var clockAlwaysGlyph = (props => useIcon(SvgClockAlwaysGlyph, SvgClockAlwaysGlyphSecondary, props));

export { clockAlwaysGlyph as default };
